module.exports = __webpack_public_path__ + "assets/img/Kitome-Blog-w720.3eb0477c.jpg";